(() => {
  if (window.__wimPcardSizeAtcInit) return;
  window.__wimPcardSizeAtcInit = true;

  const DRAG_THRESHOLD_PX = 4;
  const dragStateBySlider = new WeakMap();

  const getVariantOptions = (variant) => {
    if (Array.isArray(variant.options)) return variant.options;
    const out = [];
    if (variant.option1 != null && variant.option1 !== '') out.push(variant.option1);
    if (variant.option2 != null && variant.option2 !== '') out.push(variant.option2);
    if (variant.option3 != null && variant.option3 !== '') out.push(variant.option3);
    return out;
  };

  const norm = (v) => String(v == null ? '' : v).trim();

  const parseVariants = (wrapper) => {
    const el = wrapper.querySelector('script[type="application/json"][data-pcard-variants]');
    if (!el || !el.textContent) return [];
    try {
      return JSON.parse(el.textContent);
    } catch {
      return [];
    }
  };

  const getSelectedColorValue = (card, wrapper) => {
    const swatchList = card.querySelector('ul[is="color-swatch"]');
    if (swatchList) {
      let li = swatchList.querySelector('li.swatch-item[aria-selected="true"]');
      if (!li) li = swatchList.querySelector('li[data-initial-selected="true"]');
      if (li && li.dataset.swatchValue != null && li.dataset.swatchValue !== '') {
        return li.dataset.swatchValue;
      }
    }
    const fallback = wrapper.dataset.initialColorValue;
    return fallback != null && fallback !== '' ? fallback : null;
  };

  const findVariant = (variants, sizeIndex, sizeValue, hasColor, colorIndex, colorValue, preferAvailable = true) => {
    const sz = norm(sizeValue);
    const col = hasColor ? norm(colorValue) : null;

    const matchOne = (onlyAvailable) =>
      variants.find((v) => {
        const opts = getVariantOptions(v);
        if (opts.length <= sizeIndex) return false;
        if (norm(opts[sizeIndex]) !== sz) return false;
        if (hasColor && colorIndex != null) {
          if (opts.length <= colorIndex) return false;
          if (norm(opts[colorIndex]) !== col) return false;
        }
        if (onlyAvailable) return v.available !== false;
        return true;
      });

    if (preferAvailable) return matchOne(true) || null;
    return matchOne(true) || matchOne(false);
  };

  const isSizeAvailable = (variants, sizeIndex, sizeValue, hasColor, colorIndex, colorValue) =>
    Boolean(findVariant(variants, sizeIndex, sizeValue, hasColor, colorIndex, colorValue, true));

  const syncSizeAvailability = (wrapper) => {
    const card = wrapper.closest('.product-card');
    if (!card) return;

    const sizeIndex = Number(wrapper.dataset.sizeOptionIndex);
    if (Number.isNaN(sizeIndex)) return;

    const hasColor = wrapper.dataset.hasColorOption === 'true';
    const colorIndex = hasColor ? Number(wrapper.dataset.colorOptionIndex) : NaN;
    const variants = parseVariants(wrapper);
    if (!variants.length) return;

    const colorValue = getSelectedColorValue(card, wrapper);
    const soldOutLabel =
      (FoxTheme.variantStrings && FoxTheme.variantStrings.soldOut) || 'Agotado';

    wrapper.querySelectorAll('.wim-pcard-size-atc-btn').forEach((btn) => {
      const sizeValue = btn.dataset.sizeValue;
      const available = isSizeAvailable(
        variants,
        sizeIndex,
        sizeValue,
        hasColor && !Number.isNaN(colorIndex),
        hasColor && !Number.isNaN(colorIndex) ? colorIndex : null,
        colorValue
      );

      btn.classList.toggle('wim-size-selector__label--unavailable', !available);
      btn.disabled = !available;
      btn.setAttribute(
        'aria-label',
        available
          ? `${(FoxTheme.variantStrings && FoxTheme.variantStrings.addToCart) || 'Añadir al carrito'}: ${sizeValue}`
          : `${sizeValue} — ${soldOutLabel}`
      );

      const item = btn.closest('.size-selector__item');
      item?.classList.toggle('size-selector__item--unavailable', !available);
    });
  };

  const syncAllSizeAvailability = (root = document) => {
    root.querySelectorAll('.product-card__size-selector-wrapper').forEach(syncSizeAvailability);
  };

  const addVariantToCart = async (variantId, button) => {
    if (!window.FoxTheme || !FoxTheme.routes || !FoxTheme.utils) return;

    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    button.classList.add('wim-pcard-size-atc--loading');
    button.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch(`${FoxTheme.routes.cart_add_url}`, config);
      const parsed = await res.json();

      if (parsed && parsed.status) {
        const msg =
          (parsed.description && String(parsed.description)) ||
          (FoxTheme.cartStrings && FoxTheme.cartStrings.error) ||
          'Cart error';
        window.alert(msg);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { open: true },
        })
      );
    } catch (e) {
      console.error(e);
      window.alert((FoxTheme.cartStrings && FoxTheme.cartStrings.error) || 'Cart error');
    } finally {
      button.classList.remove('wim-pcard-size-atc--loading');
      button.removeAttribute('aria-disabled');
    }
  };

  const initDragSlider = (slider) => {
    if (slider.classList.contains('js-drag-initialized')) return;
    slider.classList.add('js-drag-initialized');

    const state = {
      isDown: false,
      moved: false,
      startPageX: 0,
      startX: 0,
      scrollLeft: 0,
    };
    dragStateBySlider.set(slider, state);

    slider.addEventListener('mousedown', (e) => {
      state.isDown = true;
      state.moved = false;
      state.startPageX = e.pageX;
      const rect = slider.getBoundingClientRect();
      state.startX = e.pageX - rect.left;
      state.scrollLeft = slider.scrollLeft;
      slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('mouseleave', () => {
      state.isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mouseup', () => {
      state.isDown = false;
      slider.style.cursor = 'grab';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!state.isDown) return;
      if (Math.abs(e.pageX - state.startPageX) > DRAG_THRESHOLD_PX) state.moved = true;
      e.preventDefault();
      const rect = slider.getBoundingClientRect();
      const x = e.pageX - rect.left;
      const walk = (x - state.startX) * 2;
      slider.scrollLeft = state.scrollLeft - walk;
    });

    slider.addEventListener(
      'click',
      (e) => {
        if (state.moved) {
          e.preventDefault();
          e.stopPropagation();
          state.moved = false;
        }
      },
      true
    );
  };

  const initAllSliders = (root = document) => {
    root.querySelectorAll('.product-card__size-selector:not(.js-drag-initialized)').forEach(initDragSlider);
  };

  const onSizeActivate = async (btn) => {
    if (btn.disabled || btn.classList.contains('wim-size-selector__label--unavailable')) return;

    const wrapper = btn.closest('.product-card__size-selector-wrapper');
    const card = btn.closest('.product-card');
    if (!wrapper || !card) return;

    const sizeIndex = Number(wrapper.dataset.sizeOptionIndex);
    if (Number.isNaN(sizeIndex)) return;

    const hasColor = wrapper.dataset.hasColorOption === 'true';
    const colorIndex = hasColor ? Number(wrapper.dataset.colorOptionIndex) : NaN;

    const variants = parseVariants(wrapper);
    if (!variants.length) return;

    const sizeValue = btn.dataset.sizeValue;
    const colorValue = getSelectedColorValue(card, wrapper);

    if (hasColor && (colorValue == null || colorValue === '')) {
      window.alert(
        (FoxTheme.variantStrings && FoxTheme.variantStrings.unavailable) || 'Selecciona un color primero.'
      );
      return;
    }

    const variant = findVariant(
      variants,
      sizeIndex,
      sizeValue,
      hasColor && !Number.isNaN(colorIndex),
      hasColor && !Number.isNaN(colorIndex) ? colorIndex : null,
      colorValue,
      true
    );

    if (!variant || !variant.id || variant.available === false) {
      window.alert(
        (FoxTheme.variantStrings && FoxTheme.variantStrings.unavailable) || 'Combinación no disponible.'
      );
      return;
    }

    await addVariantToCart(variant.id, btn);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wim-pcard-size-atc-btn');
    if (!btn) return;
    const slider = btn.closest('.product-card__size-selector');
    const dragState = slider ? dragStateBySlider.get(slider) : null;
    if (dragState && dragState.moved) {
      e.preventDefault();
      e.stopPropagation();
      dragState.moved = false;
      return;
    }
    e.preventDefault();
    onSizeActivate(btn);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const btn = e.target.closest('.wim-pcard-size-atc-btn');
    if (!btn) return;
    e.preventDefault();
    onSizeActivate(btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllSliders();
      syncAllSizeAvailability();
    });
  } else {
    initAllSliders();
    syncAllSizeAvailability();
  }

  const mo = new MutationObserver(() => {
    initAllSliders();
    syncAllSizeAvailability();
  });
  mo.observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'mouseover',
    (event) => {
      const swatchItem = event.target.closest('ul[is="color-swatch"] li.swatch-item');
      if (!swatchItem) return;

      const card = swatchItem.closest('.product-card');
      const wrapper = card?.querySelector('.product-card__size-selector-wrapper');
      if (wrapper) syncSizeAvailability(wrapper);
    },
    { passive: true }
  );
})();
